import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactCTASection from './components/ContactCTASection';
import WhyChooseSection from './components/WhyChooseSection';
import useSeo from '@/hooks/useSeo';
import { ASSETS } from '@/constants/assets';

export default function Home() {
  const location = useLocation();

  useSeo({
    title: 'Pilar Manutenção Industrial | Hidráulica Industrial, Reparo e Locação de Equipamentos',
    description: 'Especialistas em manutenção industrial, hidráulica industrial, reparo de equipamentos, componentes hidráulicos e locação de soluções para a indústria.',
    keywords: 'manutenção industrial, hidráulica industrial, reparo de equipamentos, componentes hidráulicos, DURAFLOW, Grupo Pilar, Aracruz, ES',
    canonical: 'https://www.pilarmanutencao.com.br/',
    ogUrl: 'https://www.pilarmanutencao.com.br/',
    ogImage: ASSETS.logoPilar,
  });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gp-graphite">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <WhyChooseSection />
        <ServicesSection />
        <TestimonialsSection />
        <ContactCTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}